import { useState } from "react";
import { FormDialog } from "../../ui/form-dialog";
import { PasswordField } from "../ui/passwordField";
import { useChangePassword } from "../../../hooks/auth/useChangePassword";
import { useToast } from "../../../contexts/toast/Context";

const noop = () => {};

export const ChangePasswordRequiredDialog = () => {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const { mutate, isPending } = useChangePassword();
  const { showToast } = useToast();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (newPassword.length < 8) {
      showToast("La nueva contraseña debe tener al menos 8 caracteres", "error");
      return;
    }
    if (newPassword !== confirmPassword) {
      showToast("Las contraseñas nuevas no coinciden", "error");
      return;
    }
    if (newPassword === currentPassword) {
      showToast("La nueva contraseña debe ser distinta de la actual", "error");
      return;
    }
    mutate({ currentPassword, newPassword });
  };

  const submitDisabled =
    !currentPassword ||
    newPassword.length < 8 ||
    newPassword !== confirmPassword;

  return (
    <FormDialog
      open
      onOpenChange={noop}
      onSubmit={handleSubmit}
      loading={isPending}
      title="Cambia tu contraseña temporal"
      subtitle="Por seguridad, debes definir una contraseña personal antes de continuar."
      showCloseButton={false}
      cancelLabel=""
      submitLabel="Actualizar contraseña"
      submitLoadingText="Actualizando..."
      submitDisabled={submitDisabled}
    >
      <div className="space-y-4">
        <PasswordField
          label="Contraseña actual (temporal)"
          value={currentPassword}
          onChange={setCurrentPassword}
          placeholder="Pega aquí la del correo"
        />
        <PasswordField
          label="Nueva contraseña (mínimo 8 caracteres)"
          value={newPassword}
          onChange={setNewPassword}
          placeholder="Define tu contraseña personal"
        />
        <PasswordField
          label="Confirmar nueva contraseña"
          value={confirmPassword}
          onChange={setConfirmPassword}
          placeholder="Repite la nueva contraseña"
        />
      </div>
    </FormDialog>
  );
};
